import { render, staticRenderFns } from "./PanelMiniHeader.vue?vue&type=template&id=5b35b4bc&"
import script from "./PanelMiniHeader.vue?vue&type=script&lang=js&"
export * from "./PanelMiniHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelMiniHeader.vue?vue&type=style&index=0&id=5b35b4bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports